import { Box, Group, Stack, Text, ThemeIcon, Title } from "@repo/ui/core";
import { IconCircle, IconPlayerPlay } from "@repo/ui/icons";
import classes from "@styles/onsite.module.css";
import { motion } from "framer-motion";

type Props = {
  title: string;
  subtitle?: string;
  checklist?: string[];
};

export function DemoTransitionSlide({ title, subtitle, checklist }: Props) {
  return (
    <Box w="100%" maw={1000} ta="center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Stack gap="xl" align="center">
          <motion.div
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <ThemeIcon
              size={96}
              radius="xl"
              variant="light"
              color="blue"
              className={classes.glowBlue}
            >
              <IconPlayerPlay size={48} />
            </ThemeIcon>
          </motion.div>

          <Box
            h={4}
            w={80}
            style={{
              background:
                "linear-gradient(90deg, transparent, var(--mantine-color-blue-5), transparent)",
              borderRadius: 2,
            }}
          />

          <Title
            order={1}
            fw={900}
            style={{ letterSpacing: "-0.03em", textWrap: "balance" }}
            lh={1.2}
            size="clamp(32px, 4vw, 56px)"
            className={classes.gradientTextBlue}
          >
            {title}
          </Title>

          {subtitle && (
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35, duration: 0.5 }}
            >
              <Text
                size="clamp(1rem, 2vw, 1.375rem)"
                c="dimmed"
                ta="center"
                maw={600}
                lh={1.6}
              >
                {subtitle}
              </Text>
            </motion.div>
          )}

          {checklist && checklist.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.5 }}
            >
              <Box
                mt="md"
                p="xl"
                style={{
                  background: "rgba(255,255,255,0.025)",
                  border: "1px solid rgba(255,255,255,0.06)",
                  borderRadius: "var(--mantine-radius-md)",
                  textAlign: "left",
                }}
              >
                <Text size="sm" fw={600} c="dimmed" mb="md" tt="uppercase" style={{ letterSpacing: "0.05em" }}>
                  Demo Agenda
                </Text>
                <Stack gap="sm">
                  {checklist.map((item, i) => (
                    <motion.div
                      key={item}
                      initial={{ opacity: 0, x: -12 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.6 + i * 0.08, duration: 0.3 }}
                    >
                      <Group gap="sm" wrap="nowrap">
                        <IconCircle
                          size={14}
                          style={{ color: "var(--mantine-color-blue-5)", flexShrink: 0 }}
                        />
                        <Text size="md" lh={1.5}>
                          {item}
                        </Text>
                      </Group>
                    </motion.div>
                  ))}
                </Stack>
              </Box>
            </motion.div>
          )}
        </Stack>
      </motion.div>
    </Box>
  );
}
